import { Card, CardActions, CardContent, Grid, Skeleton } from '@mui/material'

export default function TaxNumberSkeleton() {
  return <Grid item xs={12} md={6} lg={4}>
    <Card elevation={0} sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      '& .MuiSkeleton-root': {
        backgroundColor: '#dedede',
      },
    }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Skeleton variant="text" width="38%" height={24} />
        <Skeleton variant="text" width="64%" height={21} />
        <Skeleton variant="text" width="86%" height={17} />
      </CardContent>
      <CardActions sx={{ minHeight: 42, backgroundColor: 'rgba(0, 0, 0, 0.11)' }} />
    </Card>
  </Grid>
}
